module.exports = __webpack_public_path__ + "static/media/forgotImage.7ae4a924.png";